import { Component, Input, OnInit } from '@angular/core';
import { ContinentType } from '../common-interfaces-classes/ContinentType';
import { LocalStorageService } from '../_services/local-storage.service';
import { ContinentHandlerService } from '../_services/continent-handler.service';
import { TalentInsightsReqHandlerService } from '../_services/talent-insights-req-handler.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EuropeAccessModalComponent } from '../europe-access-modal/europe-access-modal.component';
import { AggregationService } from '../_services/aggregation.service';
import { AiSourcingService } from '../_services/ai-sourcing.service';

@Component({
    selector: 'app-continent-selector',
    templateUrl: './continent-selector.component.html',
    styleUrls: ['./continent-selector.component.scss'],
    standalone: false
})
export class ContinentSelectorComponent implements OnInit {

  private REGION = {
    GENERAL: "region",
    TALENT_INSIGHTS: "talentRegion"
  };

  showregion: ContinentType;
  @Input() parentRegion: ContinentType;
  isTalentInsightsTab: Boolean = false;
  hasEUAccess: any;
  hasEUTalentInsights: any;
  haseuaisourcingaccess: any;
  isAISourcingTab: boolean = false;

  constructor(
    private localStorageService: LocalStorageService,
    private continentHandlerService: ContinentHandlerService,
    private talentInsightsReqHandler: TalentInsightsReqHandlerService,
    private modalService: NgbModal,
    private aggsService: AggregationService,
    private aiSourcingService: AiSourcingService
  ) {

    this.hasEUAccess = this.localStorageService.getItem('hasEUPersonSearchAccess');
    this.hasEUTalentInsights = this.localStorageService.getItem('hasEUTalentInsightsAccess');
    this.haseuaisourcingaccess = this.localStorageService.getItem('haseuaisourcingaccess');
    const continentUpdateObs = this.continentHandlerService.continentUpdateObservable.subscribe(continent => {
      this.showregion = continent;
    });


   }

  ngOnInit() {
    if (this.parentRegion) {
      this.showregion = this.parentRegion;
      // this.localStorageService.setItem(this.REGION, this.parentRegion);
    } else if (this.talentInsightsReqHandler.isTalentInsightsTab) {
      this.showregion = this.localStorageService.getItem(this.REGION.TALENT_INSIGHTS);
    } else {
      this.showregion = this.localStorageService.getItem(this.REGION.GENERAL);
    }
    this.isTalentInsightsTab = this.talentInsightsReqHandler.isTalentInsightsTab;
    this.isAISourcingTab = this.aiSourcingService.isAISourcingTab;
    const continentEUAcess = this.aggsService.getContinentEvent.subscribe(res => this.getEUAccess(res));

  }

  selectRegion(region: ContinentType) {

      if(this.hasEUAccess == 1 && region == 'europe') {
        this.showEUAccessModal();
      } else {
        if (this.showregion === region)
        return;
        this.showregion = region;
        this.continentHandlerService.emitContinentUpdate(region);
      }

  }

  showEUAccessModal() {
    const euData = this.localStorageService.getItem('euConscent');
    const now = new Date().getTime();

    if(euData) {
      const parsedData = JSON.parse(euData);
      if(!parsedData.lastShown || now - parseInt(parsedData.lastShown, 10) > 24 * 60 * 60 * 1000) {
        const modalRef = this.modalService.open(EuropeAccessModalComponent, { windowClass: 'euAccessModal', centered: true, backdrop: 'static', keyboard: false });
        modalRef.result.then((res)=>{
          if(res.action == "success") {
            this.showregion = 'europe';
            this.continentHandlerService.emitContinentUpdate('europe');
          }
        })
      } else {
        this.showregion = 'europe';
        this.continentHandlerService.emitContinentUpdate('europe');
      }
    } else {
      const modalRef = this.modalService.open(EuropeAccessModalComponent, { windowClass: 'euAccessModal', centered: true, backdrop: 'static', keyboard: false });
      modalRef.result.then((res)=>{
        if(res.action == "success") {
          this.showregion = 'europe';
          this.continentHandlerService.emitContinentUpdate('europe');
        }
      })
    }

 }

 getEUAccess(response) {
  this.hasEUAccess = this.localStorageService.getItem('hasEUPersonSearchAccess');
  this.hasEUTalentInsights = this.localStorageService.getItem('hasEUTalentInsightsAccess');
  this.showregion = response;
 }

}
